import { render } from "./UserForm.vue?vue&type=template&id=2c3db3b5&scoped=true"
import script from "./UserForm.vue?vue&type=script&lang=js"
export * from "./UserForm.vue?vue&type=script&lang=js"

import "./UserForm.vue?vue&type=style&index=0&id=2c3db3b5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c3db3b5"]])

export default __exports__